<main class="mx-auto flex w-full max-w-[1440px] flex-col px-4 py-6 text-[var(--color-text-strong)] sm:px-8">
    <app-back-home />

    <h1 class="mt-4 font-shBreeHeadline text-3xl leading-tight text-[var(--logo-1)]">
        {{ 'workers-council-groups.list.title' | translate }}
    </h1>

    <section class="mt-8 w-full" [attr.aria-busy]="isLoading()">
        <div
            class="mb-1 grid grid-cols-1 border-b border-[rgb(var(--ui-6))] pb-3 md:grid-cols-[minmax(14rem,1fr)_minmax(0,2fr)] md:gap-6"
        >
            <div [attr.aria-sort]="groupsSorted ? 'ascending' : 'descending'">
                <button
                    type="button"
                    class="inline-flex items-center gap-2 text-left text-xs font-bold text-[var(--text-secondary)] hover:text-[rgb(var(--ui-2))]"
                    [attr.aria-label]="'workers-council-groups.list.gbr-unit' | translate"
                    (click)="sortBRUnit()"
                >
                    {{ 'workers-council-groups.list.gbr-unit' | translate }}
                    <span class="icon-caret-sort-{{ groupsSorted ? 'down' : 'up' }}" aria-hidden="true"></span>
                </button>
            </div>
            <span class="hidden text-xs font-bold text-[var(--text-secondary)] md:block">
                {{ 'workers-council-groups.list.delegates' | translate }}
            </span>
        </div>

        @if (groups(); as groups) {
            <div>
                @for (group of groups; track group.id) {
                    <article
                        class="grid gap-3 border-b border-[rgb(var(--ui-6))] py-4 md:grid-cols-[minmax(14rem,1fr)_minmax(0,2fr)] md:items-center md:gap-6"
                    >
                        <div class="min-w-0">
                            <span class="mb-1 block text-xs font-bold text-[var(--text-secondary)] md:hidden">
                                {{ 'workers-council-groups.list.gbr-unit' | translate }}
                            </span>
                            <h2 class="m-0 break-words text-base font-semibold">{{ group.name }}</h2>
                        </div>

                        <div class="flex min-w-0 flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                            <div class="flex min-w-0 flex-wrap items-center gap-2">
                                <span
                                    class="mb-1 block w-full text-xs font-bold text-[var(--text-secondary)] md:hidden"
                                >
                                    {{ 'workers-council-groups.list.delegates' | translate }}
                                </span>
                                @for (delegate of group.delegates ?? []; track delegate.gid) {
                                    <sh-tag
                                        [removable]="true"
                                        [label]="delegate.firstName + ' ' + delegate.lastName"
                                        (closed)="onRemoveDelegate(group.id, delegate.gid)"
                                    />
                                } @empty {
                                    <span class="text-sm text-[var(--text-secondary)]">-</span>
                                }
                            </div>

                            <sh-button
                                class="shrink-0 self-start sm:self-auto"
                                color="primary"
                                icon="plus"
                                iconPosition="left"
                                layout="compact"
                                [label]="'workers-council-groups.list.add-delegate' | translate"
                                [ariaLabel]="'workers-council-groups.list.add-delegate' | translate"
                                (clicked)="openPickerDialog(group.id, group.delegates ?? [])"
                            />
                        </div>
                    </article>
                }
            </div>
        }

        @if (isLoading()) {
            <div class="relative min-h-24">
                <sh-spinner size="m" overlay />
            </div>
        }
    </section>
</main>
